import React from "react";
import HomeHero from "../components/pagesComponents/homePageComponents/HomeHero";
import WhyJoinUs from "../components/pagesComponents/homePageComponents/whyJoinUs";
import WhatWeOffer from "../components/pagesComponents/homePageComponents/whatWeOffer";
import Subscribe from "../components/pagesComponents/homePageComponents/Subscribe";
import GetStarted from "../components/pagesComponents/homePageComponents/GetStarted";

const Home: React.FC = () => {
  return ( 
    <>
    <HomeHero />
    <WhyJoinUs />
    <WhatWeOffer />
    <Subscribe />
    <GetStarted />
    </>
  );
};

export default Home;
